import { useCallback } from 'react'
import type { MutationHook } from '@commerce/utils/types'
import { CommerceError } from '@commerce/utils/errors'
import useActivate, { UseActivate } from '@commerce/auth/use-activate'
import type { ActivateHook } from '../types/activate'
import useCustomer from '../customer/use-customer'

import {
  setCustomerToken,
  throwUserErrors,
  customerActivateByUrlMutation,
} from '../utils'
import { Mutation, MutationCustomerActivateByUrlArgs } from '../schema'

export default useActivate as UseActivate<typeof handler>

export const handler: MutationHook<ActivateHook> = {
  fetchOptions: {
    query: customerActivateByUrlMutation,
  },
  async fetcher({ input: { password, activationUrl }, options, fetch }) {
    if (!(password)) {
      throw new CommerceError({
        message:
          'A password is required to activate your account',
      })
    }

    const { customerActivateByUrl } = await fetch<
      Mutation,
      MutationCustomerActivateByUrlArgs
    >({
      ...options,
      variables: {
        password,
        activationUrl,
      },
    })
    throwUserErrors(customerActivateByUrl?.customerUserErrors)

    return null
  },
  useHook: ({ fetch }) => () => {
    const { mutate } = useCustomer()

    return useCallback(
      async function activate(input) {
        const data = await fetch({ input })
        await mutate()
        return data
      },
      [fetch, mutate]
    )
  },
}
